module.exports = __webpack_public_path__ + "../resources/img/img_ef_layer2_no-inverter-no-battery.e1a2f5b9.svg";